<template>
    <div v-resize="onResize" class="fill-height mt-n3 mx-n4" ref="container">
        <v-tabs
            ref="tabs"
            active-class="white"
            background-color="grey lighten-3"
            hide-slider
            show-arrows
        >
            <v-tab
                :to="{
                    name: activeRoute('project-part-numbers'),
                    params: {
                        projectId,
                    },
                }"
            >
                PART NUMBERS
            </v-tab>
            <v-tab
                :to="{
                    name: activeRoute('project-work-orders'),
                    params: {
                        projectId: projectId,
                        project: project,
                    },
                }"
            >
                WO
            </v-tab>

            <v-tab
                :to="{
                    name: activeRoute('project-wo-progress'),
                    params: {
                        projectId: projectId,
                        project: project,
                    },
                }"
            >
                WO PROGRESS
            </v-tab>

            <v-tab
                :to="{
                    name: activeRoute('project-bill-of-materials'),
                    params: {
                        projectId: projectId,
                    },
                }"
            >
                BOM
            </v-tab>

            <v-tab
                :to="{
                    name: activeRoute('project-packing-lists'),
                    params: {
                        projectId: projectId,
                    },
                }"
            >
                PACKING LISTS
            </v-tab>
            <v-tab
                :to="{
                    name: activeRoute('project-wo-balance'),
                    params: {
                        projectId: projectId,
                    },
                }"
            >
                WO BALANCE
            </v-tab>
        </v-tabs>
        <v-card>
            <v-card-text
                class="overflow-y-auto"
                :style="{ height: `${height}px` }"
            >
                <router-view />
            </v-card-text>
        </v-card>
        <Errors />
    </div>
</template>

<script>
export default {
    name: 'ProjectProduction',
    props: {
        projectId: String,
        project: Object,
    },
    components: {
        Errors: () => import('@/components/Layout/Errors.vue'),
    },
    data: () => ({
        height: 0,
        nameRoute: undefined,
    }),
    created() {
        this.nameRoute = this.$router.currentRoute.path
    },
    methods: {
        activeRoute(tabName) {
            const routes = this.nameRoute.split('/')
            if (routes.find(route => route.includes('archive-project'))) {
                return `archive-${tabName}`
            }
            if (routes.find(route => route == 'projects')) {
                return `${tabName}`
            }
            if (routes.find(route => route == 'projects-generic')) {
                return `${tabName}-generic`
            }
        },
        onResize() {
            const {
                container: { clientHeight: containerHeight },
                tabs: {
                    $el: { clientHeight: tabsHeight },
                },
            } = this.$refs
            this.height = containerHeight - tabsHeight + 28
        },
    },
}
</script>

<style></style>
